import constants from './lib/constants';

const app = {
	apiRoot: '',
	live: true,
	locale: 'nl_NL',
	theme: constants.THEME_DEFAULT,
	paymentSession: {},
	adyen: {
		clientKey: false,
		countryCodes: {},
		paymentMethods: [],
	},

	init: () => {
		app.apiRoot = app.getEnvParam(process.env.API_ROOT);
		
		// If hosted on .es domain, adjust API root to also end with .es
		if (typeof window !== 'undefined' && window.location.hostname.endsWith('.es')) {
			app.apiRoot = app.adjustApiRootForDomain(app.apiRoot);
		}
		
		app.live = app.getEnvParam(process.env.LIVE) == 1 ? true : false;
		app.locale = app.getEnvParam(process.env.LOCALE);
		app.adyen.clientKey = app.getEnvParam(process.env.ADYEN_CLIENT_KEY);
		app.paymentSession = {};
		app.theme = app.loadTheme();
	},

	adjustApiRootForDomain: (apiRoot) => {
		try {
			const url = new URL(apiRoot);
			// Replace the hostname's TLD with .es
			const hostnameParts = url.hostname.split('.');
			if (hostnameParts.length >= 2) {
				// Remove the last part (TLD) and add .es
				hostnameParts[hostnameParts.length - 1] = 'es';
				url.hostname = hostnameParts.join('.');
			}
			return url.toString();
		} catch (e) {
			// If URL parsing fails, return original
			return apiRoot;
		}
	},

	loadTheme: () => {
		const date = new Date();

		// if december return christmas theme
		if (date.getMonth() === 11) {
			return constants.THEME_CHIRSTMAS;
		}

		return constants.THEME_DEFAULT;
	},

	getEnvParam: (value) => {
		if (value == undefined) {
			window.alert('Failed to load enviroment');
		}

		return value;
	},
};

export default app;
